import { render, staticRenderFns } from "./MySecretPrescriptionDetail.vue?vue&type=template&id=08a0c9a5"
import script from "./MySecretPrescriptionDetail.vue?vue&type=script&lang=js"
export * from "./MySecretPrescriptionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports